import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import {HolidaysCalendarDTO} from './dto/holidays-calendar.dto';
import {HolidaysCalenderService} from './holidays-calender.service';
import { HolidaysResponseModel, AllHolidaysCalendarResponseModel } from '@gtpl/shared-models/hrms';
import { HolidaysCalendarRequest } from './dto/holidays-calendar.request';
import { CommonResponse } from '@gtpl/shared-models/masters';


@Controller('holidays-calender')
export class HolidaysCalenderController {
    constructor(
        private holidaysCalendarService: HolidaysCalenderService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createHoliday')
    async createHoliday(@Body() holidaysCalendarDto:HolidaysCalendarDTO,isUpdate:boolean=false): Promise<HolidaysResponseModel> {
    try {
        return await this.holidaysCalendarService.createHoliday(holidaysCalendarDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(HolidaysResponseModel, error);
      }
    }
    @Post('/updateHoliday')
  async updateHoliday(@Body() holidaysCalendarDto: HolidaysCalendarDTO,@Req() request:Request): Promise<HolidaysResponseModel> {
    try {
      console.log('update Holiday');holidaysCalendarDto
      console.log(request);
      return await this.holidaysCalendarService.createHoliday(holidaysCalendarDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(HolidaysResponseModel, error);
    }
  }
  @Post('/getAllHolidays')
  // @UseGuards(AuthGuard('jwt'))
  async getAllHolidays(): Promise<AllHolidaysCalendarResponseModel> {
    try {
      return await this.holidaysCalendarService.getAllHolidays();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllHolidaysCalendarResponseModel, error);
    }
  }
  @Post('/activateOrDeactivateHoliday')
  async activateOrDeactivateHoliday(@Body() holidayCalendarReq: HolidaysCalendarRequest): Promise<HolidaysResponseModel> {
      try {
          return await this.holidaysCalendarService.activateOrDeactivateHoliday(holidayCalendarReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HolidaysResponseModel, err);
      }
  }
  @Post('/getAllActiveHolidays')
  async getAllActiveHolidays(@Req() request: Request): Promise<AllHolidaysCalendarResponseModel> {
      try {
          return await this.holidaysCalendarService.getAllActiveHolidays();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllHolidaysCalendarResponseModel, error)
      }
  }
  @Post('/getHolidayById')
  async getHolidayById(@Body() holidayCalendarReq: HolidaysCalendarRequest): Promise<HolidaysResponseModel> {
      try {
          return await this.holidaysCalendarService.getActiveHolidaysById(holidayCalendarReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HolidaysResponseModel, err);
      }
  }

  @Post('/getHolidaysForYear')
  async getHolidaysForYear(): Promise<CommonResponse> {
    try {
      return await this.holidaysCalendarService.getHolidaysForYear();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
}
